import * as React from 'react';
import { NewbuildingCarousel, TDirection, TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';
import { IBank } from '../../types/bank';
import { firstPaintOptions, mediaSettings } from '../Carousel/config';
import { Slide, ArrowControls } from './parts';
import * as styles from './BanksSlider.css';

interface IBanksSliderProps {
  otherBanks: IBank[];
  locationId: number;
}

interface IBankSliderState {
  banksSlides: React.ReactNode[];
  currentSlide: number;
}

export class BanksSlider extends React.Component<IBanksSliderProps, IBankSliderState> {
  public constructor(props: IBanksSliderProps) {
    super(props);

    this.state = {
      banksSlides: this.prepareBankSlides(this.props.otherBanks),
      currentSlide: 1,
    };
  }

  public componentDidUpdate(prevProps: Readonly<IBanksSliderProps>) {
    const { otherBanks, locationId } = this.props;

    const banksChanged =
      otherBanks.length === prevProps.otherBanks.length &&
      otherBanks.every(function (element, index) {
        return element === prevProps.otherBanks[index];
      });

    if (locationId !== prevProps.locationId || !banksChanged) {
      this.setState({ banksSlides: this.prepareBankSlides(otherBanks), currentSlide: 1 });
    }
  }

  public prepareBankSlides = (banks: IBank[]) => {
    return banks.map((bank, index) => {
      return (
        <Slide
          key={index}
          position={index}
          name={bank.bankName}
          rate={bank.rate}
          initialInstallment={bank.initialInstallment}
          licenseText={bank.licenseText}
          amountText={bank.amount}
          maxLoanTerm={bank.maxTerm}
          logo={bank.icon}
        />
      );
    });
  };

  private handleArrowsClick = (direction: TDirection) => {
    this.setState({
      currentSlide: this.state.currentSlide + direction * 1,
    });
  };

  private handleSlideChange = ({ currentSlide }: TOnSlideChangeParams) => {
    this.setState({
      currentSlide,
    });
  };

  public render() {
    const { currentSlide, banksSlides } = this.state;

    return (
      <div className={styles['container']}>
        <NewbuildingCarousel
          media={mediaSettings}
          firstPaintOptions={firstPaintOptions}
          slides={banksSlides}
          defaultCurrentSlide={currentSlide}
          onSlideChange={this.handleSlideChange}
        />

        {banksSlides.length > 1 && (
          <ArrowControls
            disableLeft={currentSlide === 1}
            disableRight={currentSlide === banksSlides.length}
            clickHandler={this.handleArrowsClick}
          />
        )}
      </div>
    );
  }
}
